<svelte:options customElement="clever-search-chat-in-page" />

<script lang="ts">
  /** stores */
  import { ConfigStore } from './lib/store/config';
  import { state_showSearch } from './lib/store/state';
  /** others */
  import { fly } from 'svelte/transition';
  import { WidgetType } from './lib/enums/widget-type.enum';
  import { shadowDomUpdates } from './lib/helpers/shadowdom-updates';
  import { onMount } from 'svelte';

  import ChatBotHeader from './lib/components/chat-bot-header.svelte';

  $ConfigStore = {
    ...$ConfigStore,
    widgetType: WidgetType.cip,
  };

  onMount(() => {
    shadowDomUpdates('clever-search-chat-in-page', true);
  });
</script>

{#if !!$ConfigStore.apiBaseUrl}
  <div
    class="cs-wrapper"
    transition:fly|global={{
      y: 50,
      duration: 1000,
    }}
  >
    <ChatBotHeader />
    <clever-search-chat />
  </div>
{/if}
